export default __webpack_public_path__ + "static/media/event-2.b4aa3b9f.png";